import React, { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom"; // <-- not useParams
import { Button, Divider, Grid, Typography } from "@material-ui/core";
import { VacancyAppRepository } from "../VacancyAppRepository";
import { CloudDownload } from "@material-ui/icons";

export default function VacancyApplicationDocumentVerification() {
  const location = useLocation();

  // everything after "/vacancyAppDocs/verify/"
  const decodedToken = useMemo(() => {
    const prefix = "/vacancyAppDocs/verify/";
    const idx = location.pathname.indexOf(prefix);
    const raw =
      idx >= 0 ? location.pathname.substring(idx + prefix.length) : "";
    try {
      return decodeURIComponent(raw || "");
    } catch {
      return raw || "";
    }
  }, [location.pathname]);

  const [documentData, setDocumentData] = useState(null);
  const [vacancyAppDocData, setVacancyAppDocData] = useState(null);
  const [vacancyAppData, setVacancyAppData] = useState(null);

  // 1) Verify
  useEffect(() => {
    if (!decodedToken) return;
    (async () => {
      try {
        const res = await VacancyAppRepository.verifyVacancyApp(decodedToken);
        setDocumentData(res.data ?? true);
      } catch (e) {
        setDocumentData(null);
        console.error(e);
      }
    })();
  }, [decodedToken]);

  // 2) Load doc by token
  useEffect(() => {
    if (!decodedToken) return;
    (async () => {
      try {
        const res = await VacancyAppRepository.getVacancyAppByToken(
          decodedToken
        );
        setVacancyAppDocData(res.data);
      } catch (e) {
        setVacancyAppDocData(null);
        console.error(e);
      }
    })();
  }, [decodedToken]);

  // 3) Load vacancyApp
  useEffect(() => {
    if (!vacancyAppDocData?.vacancyAppId) return;
    (async () => {
      try {
        const res = await VacancyAppRepository.get(
          vacancyAppDocData.vacancyAppId
        );
        setVacancyAppData(res.data);
      } catch (e) {
        setVacancyAppData(null);
        console.error(e);
      }
    })();
  }, [vacancyAppDocData?.vacancyAppId]);

  const handleApplicationDownload = async () => {
    try {
      if (!vacancyAppDocData?.vacancyAppId) return;
      const response = await VacancyAppRepository.printOriginalVacancyApp(
        vacancyAppDocData.vacancyAppId
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${vacancyAppDocData.vacancyAppId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download file:", err);
    }
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  return (
    <>
      <Grid
        container
        style={{
          alignContent: "center",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          item
          xs={10}
          style={{
            maxWidth: "800px",
            marginTop: "5%",
            background: "white",
            border: "2px solid rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(30px)",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            borderRadius: "10px",
            padding: "20px 30px",
          }}
        >
          <Grid container spacing={2} style={{ backgroundColor: "#f7f1d7" }}>
            <Grid item>
              <img
                alt=""
                src={require("../../../assets/img/grb_gold.png")}
                width="80px"
                style={{
                  opacity: "50%",
                }}
              ></img>
            </Grid>
            <Grid item>
              <p>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    opacity: "70%",
                  }}
                >
                  МИНИСТЕРСТВО ЗА ОБРАЗОВАНИЕ И НАУКА
                </span>

                <br />
                <span style={{ fontSize: "15px", opacity: "60%" }}>
                  Електронски систем за кариерно напредување
                </span>
              </p>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "30px" }}>
            <Grid item style={{ marginTop: "10px", marginBottom: "30px" }}>
              <Typography
                style={{
                  fontSize: "25px",
                  marginBottom: "10px",
                  opacity: "60%",
                }}
              >
                Верификација на издаден документ
                <br />
                <Divider style={{ backgroundColor: "#f7f1d7" }}></Divider>
              </Typography>
              {documentData ? (
                <Typography>
                  <b style={{ marginBottom: "20px" }}>
                    <span style={{ color: "green" }}>ВАЛИДЕН</span>
                  </b>
                </Typography>
              ) : (
                <Typography>
                  <b style={{ marginBottom: "20px" }}>
                    <span style={{ color: "red" }}>НЕВАЛИДЕН</span>
                  </b>
                </Typography>
              )}
            </Grid>

            {documentData && (
              <>
                <Grid item style={{ marginBottom: "30px" }}>
                  <Typography>
                    <b style={{ marginBottom: "20px" }}>Издаден документ: </b>
                    <div>Апликација на конкурс</div>
                    <Divider style={{ width: "200px" }}></Divider>
                    <br />
                    <b style={{ marginBottom: "20px" }}>Име на конкурс: </b>
                    <div>
                      {vacancyAppData ? vacancyAppData?.vacancy?.name : ""}
                    </div>
                    <Divider style={{ width: "200px" }}></Divider>
                    <br />
                    <b style={{ marginBottom: "20px" }}>Датум на издавање: </b>
                    <div>
                      {vacancyAppData
                        ? formatDate(vacancyAppDocData?.dateCreated)
                        : ""}
                      <br />
                    </div>
                    <Divider style={{ width: "200px" }}></Divider>
                    <br />
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    startIcon={<CloudDownload />}
                    onClick={() => {
                      handleApplicationDownload();
                    }}
                  >
                    Преземи го оригиналниот документ
                  </Button>
                </Grid>
              </>
            )}
            <Grid
              item
              style={{
                marginTop: "30px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => {
                  window.open("https://karierenrazvoj.mon.gov.mk");
                }}
              >
                www.karierenrazvoj.mon.gov.mk
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
